import React from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'

const CartButton = ({ quantity, onClick }) => {
  return (
    <div
      className='relative cursor-pointer'
      onClick={() => onClick && onClick()}
    >
      <Icon icon='mdi:cart' className='text-[36px]' />
      {quantity > 0 && (
        <div className='absolute right-0 top-1/2 flex h-[16px] min-w-[16px] -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full bg-[#E51016] px-[4px] text-[10px] font-medium text-white ring-2 ring-white'>
          {quantity}
        </div>
      )}
    </div>
  )
}

export default CartButton
